export const validate = ({ members }) => {
  const errors = { members: [] };

  if (!members || !members.length) {
    errors.members = { _error: 'At least one member must be selected' };
  }

  return errors;
};
